/**

* Shared state for live accessibility announcements.
*
* @remarks
* `AnnouncementService` writes announcement text to this store.
* `LiveAnnouncer` subscribes to the store and renders the text in
* the DOM through `aria-live` regions, allowing screen readers to
* announce the messages.
*
* The store contains only the current text for each live region.
* Timing and announcement behavior are handled by `AnnouncementService`.
  */

import type { AnnouncementState } from 'Services/announcementService/index.types';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export type {
  AnnouncementPoliteness,
  AnnouncementState,
  AnnouncementTopic,
} from 'Services/announcementService/index.types';

export const EMPTY_ANNOUNCEMENTS: AnnouncementState = {
  polite: '',
  assertive: '',
};

export const useAnnouncementStore = create<AnnouncementState>()(
  devtools(() => ({ ...EMPTY_ANNOUNCEMENTS }), {
    name: 'LiveAnnouncements',
  })
);
